/* eslint-disable no-unused-vars */
import axios from "../../../config/AxiosConfig";
import { put, call } from "redux-saga/effects";
import {
  TRANSACTIONS_API,
  ACTIVE_CAMPAIGN_LIST_API,
  INVESTOR_LIST_API,
} from "../../actions/apiCollections";
import * as actions from "../../actions/transactions/transactionsActions";

export function* getTransactions(action) {
  yield put(actions.transactionsStart());

  try {
    const response = yield axios.get(`${TRANSACTIONS_API}?lng=en`, {
      params: { limit: 10 * action.response },
    });
    yield put(actions.getTransactionsSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* getTransaction(action) {
  yield put(actions.transactionsStart());
  try {
    const response = yield axios.get(
      `${TRANSACTIONS_API}${action.campaignId}?lng=en`
    );
    yield put(actions.getTransactionSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* updateTransactionSaga(action) {
  console.log(action.response);
  yield put(actions.transactionsStart());
  try {
    const response = yield axios.patch(
      `${TRANSACTIONS_API}${action.response.tranId}?lng=en`,
      action.response
    );
    const obj = {
      response: 1,
    };
    yield call(getTransactions, obj);
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* getSearchTransactionsSaga(action) {
  yield put(actions.transactionsStart());
  try {
    const params = {};

    if (
      action.response.campaign !== "" &&
      action.response.campaign !== undefined
    ) {
      params.campaign = action.response.campaign;
    }
    if (
      action.response.investor !== "" &&
      action.response.investor !== undefined
    ) {
      params.user = action.response.investor;
    }
    if (
      action.response.minamount !== "" &&
      action.response.minamount !== undefined
    ) {
      params.minAmount = action.response.minamount;
    }
    if (
      action.response.maxamount !== "" &&
      action.response.maxamount !== undefined
    ) {
      params.maxAmount = action.response.maxamount;
    }
    if (
      action.response.transaction !== "" &&
      action.response.transaction !== undefined
    ) {
      params.transaction = action.response.transaction;
    }
    if (
      action.response.preapprovalStatus !== "" &&
      action.response.preapprovalStatus !== undefined
    ) {
      params.preapprovalStatus = action.response.preapprovalStatus;
    }
    if (action.response.byDays !== "" && action.response.byDays !== undefined) {
      params.byDays = action.response.byDays;
    }

    if (action.response.startDate) {
      params.startDate = new Date(action.response.startDate).getTime();
    }
    if (action.response.endDate) {
      params.endDate = new Date(action.response.endDate).getTime();
    }

    if (action.limitNo !== "" && action.limitNo !== undefined) {
      params.limit = 10 * action.limitNo;
    }

    const response = yield axios.get(`${TRANSACTIONS_API}?lng=en`, {
      params: params,
    });

    yield put(actions.getTransactionsSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* getActiveCamapignListSaga(action) {
  yield put(actions.transactionsStart());
  try {
    const response = yield axios.get(ACTIVE_CAMPAIGN_LIST_API);
    yield put(actions.getActiveCamapignListSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* getInvestorListSaga(action) {
  yield put(actions.transactionsStart());
  try {
    const response = yield axios.get(INVESTOR_LIST_API);
    yield put(actions.getInvestorListSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.transactionFail(error));
  }
}

export function* addTransactionSaga(action) {
  yield put(actions.transactionsStart());
  try {
    const response = yield axios.post(
      `${TRANSACTIONS_API}?lng=en`,
      action.transactionData
    );
    yield put(actions.addTransactionSuccess(response.data?.data));
    const obj = {
      response: 1,
    };
    yield call(getTransactions, obj);
  } catch (error) {
    yield put(actions.transactionFail(error?.response?.data?.message));
  }
}
